/**
 * API Auth - Compartido entre v1.0 y v2.0
 */

// API URL - Compatible con navegador y build
const API_URL = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL) 
  ? process.env.REACT_APP_API_URL 
  : 'http://localhost:4004/api';

/**
 * Login de usuario
 * @param {string} usuario - Usuario o email
 * @param {string} password - Contraseña
 * @returns {Promise<{token: string, user: object}>}
 */
export async function login(usuario, password) {
  const response = await fetch(`${API_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ usuario, clave: password })
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || error.error || 'Error de autenticación');
  }

  const data = await response.json();
  
  if (!data.success) {
    throw new Error('Error en el login');
  }

  // Construir objeto user según el tipo
  let user;
  if (data.isAdmin) {
    user = {
      CdUsuario: data.CdUsuario,
      Usuario: data.Usuario,
      Nombre: data.Nombre,
      IdRol: data.IdRol,
      AdminLevel: data.AdminLevel,
      Legajo: data.Legajo,
      CdEmpleado: data.CdEmpleado,
      PortalRRHH: 1,
      isAdmin: true,
      tipoUsuario: 2
    };
  } else {
    user = {
      Legajo: data.Legajo,
      CdEmpleado: data.CdEmpleado,
      Nombre: data.Nombre,
      IdRol: data.IdRol,
      isAdmin: false,
      tipoUsuario: (data.IdRol === 1 || data.IdRol === 99) ? 2 : 1
    };
  }
  
  // Guardar token y usuario en localStorage
  localStorage.setItem('token', data.token);
  localStorage.setItem('user', JSON.stringify(user));
  
  return { token: data.token, user };
}

/**
 * Verificar si el usuario está autenticado
 * @returns {boolean}
 */
export function isAuthenticated() {
  const token = localStorage.getItem('token');
  return !!token;
}

/**
 * Obtener token actual
 * @returns {string|null}
 */
export function getToken() {
  return localStorage.getItem('token');
}

/**
 * Obtener usuario actual
 * @returns {object|null}
 */
export function getUser() {
  const userStr = localStorage.getItem('user');
  return userStr ? JSON.parse(userStr) : null;
}

/**
 * Verificar si el usuario es admin
 * @returns {boolean}
 */
export function isAdmin() {
  const user = getUser();
  return user && user.IdRol === 1;
}

/**
 * Logout
 */
export function logout() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('switchVersion');
  localStorage.removeItem('returnUrl');
}

/**
 * Hacer request autenticado
 * @param {string} endpoint - Endpoint de la APIítica
 * @param {object} options - Opciones fetch
 * @returns {Promise<any>}
 */
export async function authenticatedFetch(endpoint, options = {}) {
  const token = getToken();
  
  if (!token) {
    throw new Error('No autenticado');
  }

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
      ...options.headers
    }
  });

  if (response.status === 401) {
    logout();
    window.location.href = '/';
    throw new Error('Sesión expirada');
  }

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Error en la solicitud');
  }

  return response.json();
}
